import { PriorityPriorityEnum } from '@/api/openapi';

const priorityWithoutNotSet = Object.values(PriorityPriorityEnum).filter((priority) => priority !== PriorityPriorityEnum.NotSet);

export default priorityWithoutNotSet;
